@if (allowEdit(comment)) {
<div class="comments-action">
  <button aria-label="Edit" class="header-button-comment header-icon-comment"
          disableRipple mat-icon-button matTooltip="Edit" (click)="onToggleEdit(comment)" 
          (keydown)="onToggleEdit(comment)">
    <mat-icon svgIcon="k12-edit"></mat-icon>
  </button>
  <button aria-label="Delete" class="header-button-comment header-icon-comment"
          disableRipple mat-icon-button matTooltip="Delete" (click)="delete(comment)" 
          (keydown)="delete(comment)">
    <mat-icon svgIcon="k12-delete"></mat-icon>
  </button>
</div>
}
@if (!this.isEdit) {
<div class="comments" [class.mt-3]="!allowEdit(comment)">
  <!-- chat pipe HTML-escapes comment.body before linkifying, so free-text input is safe -->
  <span class="comment-text comment-content" [innerHTML]="comment.body | chat: ''"></span>
  <span class="comment-text"><b>{{ comment.createdByName }} - {{ comment.dateModified }}</b></span>
</div>
}
@else {
<div class="comments-text">
  <textarea class="comments__textarea" #textComment matInput [(ngModel)]="editedComment" [rows]="4"
    placeholder="Write a comment" style="width: 100% !important; margin-bottom: 16px;" maxlength="255"></textarea>
  <div class="comments__button">
    <button mat-flat-button type="button" class="comments__cancel-btn" matTooltip="Cancel"
      (click)="onCancel()"><span>Cancel</span></button>
    <button mat-flat-button type="button" class="header-button ml-2" matTooltip="Save comment" (click)="onSaveComment()"
      [disabled]="!editedComment.trim()"><span>Save</span></button>
  </div>
</div>
}